const SpainFlag = () => (
  <svg width="16" height="12" viewBox="0 0 30 20" style={{ marginRight: '4px', verticalAlign: 'middle' }}>
    <rect width="30" height="8" fill="#AA151B"/>
    <rect y="8" width="30" height="4" fill="#F1BF00"/>
    <rect y="12" width="30" height="8" fill="#AA151B"/>
  </svg>
);

export default SpainFlag;